import React from "react";
import { object, number } from "prop-types";
import { Link } from "@quintype/components";
import get from "lodash/get";

import Headline from "../../atoms/headline";
import ResponsiveSourceImage from "../../atoms/responsive-source-image";
import PlaceholderImage from "../../atoms/placeholder-image";

import "./small-horizontal-card.m.css";

const SmallHorizontalCard = ({ story = {}, headlineLimit = 60, headerType = 8 }) => {
  const storyObj = story.story ? story.story : story;
  if (!storyObj.slug) {
    return null;
  }

  const slug = storyObj["hero-image-s3-key"];
  const storyImageSlug = get(storyObj, ["alternative", "home", "default", "hero-image", "hero-image-s3-key"], slug);

  return (
    <Link href={`/${storyObj.slug}`}>
      <div styleName="small-horizontal-card" className="small-horizontal-card">
        {storyImageSlug ? (
          <ResponsiveSourceImage
            story={storyObj}
            desktopWidths={[180, 360]}
            mobileWidths={[110, 220]}
            desktopAspectRation={[16, 9]}
            mobileAspectRation={[1, 1]}
          />
        ) : (
          <PlaceholderImage story={storyObj} />
        )}
        <Headline
          story={storyObj}
          text={storyObj.headline}
          headerLevel={2}
          headerType={headerType}
          headlineLimit={headlineLimit}
        />
      </div>
    </Link>
  );
};

export default SmallHorizontalCard;

SmallHorizontalCard.propTypes = {
  story: object,
  headerLevel: number,
  headlineLimit: number,
  headerType: number
};
